import { render, staticRenderFns } from "./Recipient.vue?vue&type=template&id=1ec5eb50&scoped=true"
import script from "./Recipient.vue?vue&type=script&lang=js"
export * from "./Recipient.vue?vue&type=script&lang=js"
import style0 from "./Recipient.vue?vue&type=style&index=0&id=1ec5eb50&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ec5eb50",
  null
  
)

export default component.exports